<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <b-navbar-nav class="nav align-items-center">
      <baixa-lote />
      <lista-observacoes />
      <feather-icon
        v-b-tooltip.hover
        title="Acessar empresas favoritas"
        icon="StarIcon"
        class="text-warning mr-1"
        size="22"
        @click="empresasFavoritas"
        style="cursor: pointer;"
      />
      <feather-icon
        id="manual-icon-btn"
        v-b-tooltip.hover
        title="Manual informativo"
        icon="HelpCircleIcon"
        class="text-body mr-1"
        size="22"
        @click="showManualModal = true"
        style="cursor: pointer;"
      />
      <certificado-vencido />
    </b-navbar-nav>

    <b-modal
      v-model="showManualModal"
      centered
      size="lg"
      scrollable
      header-class="border-0 pb-0"
      footer-class="border-0 pt-0"
      body-class="p-0"
    >
      <template #modal-header="{ close }">
        <span />
        <button type="button" aria-label="Close" class="close" @click="close()">×</button>
      </template>
      <div class="pdf-container" style="height: 65vh;">
        <iframe :src="manualUrl + '#toolbar=0&navpanes=0&view=FitH'" width="100%" height="100%" frameborder="0" style="border: none; background-color: white;"></iframe>
      </div>
      <template #modal-footer="{ close }">
        <div class="w-100 d-flex justify-content-between">
          <b-button variant="outline-primary" @click="downloadManual" class="d-flex align-items-center">
            <feather-icon icon="DownloadIcon" size="16" class="mr-50" />
            <span>Fazer download</span>
          </b-button>
          <b-button variant="outline-secondary" @click="close()">Fechar</b-button>
        </div>
      </template>
    </b-modal>

    <!-- Modal global de termos de aceite — não ocupa espaço visual -->
    <modal-termo-aceite />
    <b-navbar-brand
      class="ml-auto mr-auto"
      style="cursor: pointer"
      @click="direcionaHome"
    >
      <img
        :src="require('@/assets/images/logo/logo.png')"
        class="d-inline-block logo-navbar"
        alt="monitor_contabil"
      >
    </b-navbar-brand>
    <b-navbar-nav
      class="nav align-items-center"
      style="flex-direction: column; font-size: smaller;"
    >
      <fieldset style="color: #ff9f43; font-weight: bold;">
        <font-awesome-icon
          icon="fa-solid fa-circle-dollar-to-slot"
          style="font-size: 18px;"
          class="text-primary"
        />
        {{ credito }}
      </fieldset>
      {{ tipoPlano }}
    </b-navbar-nav>
    <sistema-indisponivel />

    <b-navbar-nav class="nav align-items-center">
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ getNome() }}
            </p>
            <span class="user-status">{{ getEmpresaNome() }}</span>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="perfilUsuario"
        >
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-60"
          />
          <span style="margin: 7px;">Perfil usuário</span>
        </b-dropdown-item>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="logout"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Sair</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<style lang="scss">
.logo-navbar {
  width: 175px;
  padding-right: 0.3rem;
  padding-left: 0.3rem;
  border-radius: 2px;
  // background-color: #29282894;
  // box-shadow: 0 4px 24px 0 rgb(34 41 47 / 80%);
}
</style>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BAvatar, BNavbarBrand, BModal, BButton,
} from 'bootstrap-vue'
import { updateAbility, getUserInfo, getUserData } from '@/auth/utils'
import useAbility from '@/libs/acl/ability'
import useJwt from '@/auth/jwt/useJwt'
import { PlanUtils } from '@pilar/utils/planUtils'
import EventBus from '@app/shared/mixins/event-bus/eventBus'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BAvatar,
    BNavbarBrand,
    BModal,
    BButton,
    BaixaLote: () => import('@/layouts/components/baixa-lote/BaixaLote.vue'),
    ListaObservacoes: () => import('@/layouts/components/lista-observacoes/ListaObservacoes.vue'),
    CertificadoVencido: () => import('@/layouts/components/certificado-vencido/CertificadoVencido.vue'),
    ModalTermoAceite: () => import('@/layouts/components/modal-termo-aceite/ModalTermoAceite.vue'),
    SistemaIndisponivel: () => import('@/layouts/components/sistema-indisponivel/SistemaIndisponivel.vue'),
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      tipoPlano: '',
      credito: 0,
      showManualModal: false,
      manualUrl: 'https://monitorcontabilstaging.s3.us-west-1.wasabisys.com/Manuais/Dicas_de_Usabilidade-Monitor_Contabil.pdf?v=2',
    }
  },
  created() {
    EventBus.$on('atualizarPlano', novoPlano => this.atualizarPlano(novoPlano))
    EventBus.$on('atualizarCredito', credito => this.atualizarCredito(credito))
    this.setTipoPlano()
    this.setCredito()
  },
  methods: {
    downloadManual() {
      fetch(this.manualUrl)
        .then(response => response.blob())
        .then(blob => {
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'Dicas_de_Usabilidade-Monitor_Contabil.pdf')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        })
        .catch(() => {
          window.open(this.manualUrl, '_blank')
        })
    },
    logout() {
      this.$router.push({ name: 'auth-login' })
    },
    getNome() {
      return getUserInfo().nome
    },
    direcionaHome() {
      this.$router.push('/')
    },
    getEmpresaNome() {
      return getUserInfo().empresa
    },
    perfilUsuario() {
      this.rota = window.location.pathname
      this.$router.push(`/usuario/editar/${getUserInfo().usuarioId}`)
      if (this.rota.match('/usuario/editar')) {
        window.location.reload()
      }
    },
    empresasFavoritas() {
      this.$router.push({ name: 'empresa-view', query: { filtroRapido: 'Favoritas' } })
    },
    setTipoPlano() {
      const userData = getUserData()
      // Utilizando o utilitário PlanUtils para obter o nome formatado do plano
      this.tipoPlano = PlanUtils.obterNomePlanoFormatado(userData.tipoPlano)
    },
    atualizarPlano(novoPlano) {
      const userData = getUserData()
      userData.tipoPlano = novoPlano
      useJwt.setUserData(userData)
      updateAbility(useAbility)
      this.setTipoPlano()
    },
    setCredito() {
      const userData = getUserData()
      this.credito = userData.credito
    },
    atualizarCredito(credito) {
      const userData = getUserData()
      userData.credito = credito
      useJwt.setUserData(userData)
      updateAbility(useAbility)
      this.setCredito()
      this.$set(this, 'credito', credito)
    },
  },
}
</script>
